<template>
    <div class="home-page home-page0">
        <div class="home-hero">
            <div class="home-topbar">
                <div class="home-brand">
                    <img class="home-logo" src="../../static/images/logo.png" alt="SnapAI" />
                </div>

                <button class="home-chances" type="button" @click="goPurchaseChances">
                    <span class="home-chances-icon"></span>
                    <span class="home-chances-value">{{ score || 0 }}</span>
                </button>

                <button class="home-menu" type="button" @click.stop="toggleMenu(true)">
                    <img class="home-menu-icon" src="../../static/images/index/index_menu.png" alt="menu" />
                </button>
            </div>
            <!-- Let's talk with SnapBot -->
            <button
                class="home-snapbot"
                type="button"
                :style="homeSnapbotBgStyle"
                @click="goDetail('/snapbot')"
            >
            </button>
        </div>

        <!-- 侧边菜单（参考 HeaderOne.vue） -->
        <div class="modal-bg" v-if="menuActive" @click="toggleMenu(false)"></div>
        <div class="menu-bg" v-if="menuActive">
            <div class="disflex mt50" style="justify-content: flex-start;">
                <img width="25" @click="toggleMenu(false)" src="../../static/images/back.png" />
                <a class="logo" style="margin: 0 0 0 0.64rem;" href="/"><img src="static/images/logo.png" /></a>
            </div>

            <div class="account ac" @click="getMenu('myAccount')">
                <div class="mt30">
                    <img src="static/images/account.png" />
                </div>
                <div class="crfff fw7">{{ info.nickname || '' }}</div>
            </div>

            <div class="chances-left ac mt20">
                <div class="cr46eed0">
                    {{$t('ChancesLeft')}}:
                    <strong class="crfff"><img width="22" src="../../static/images/hd-i1.png" />{{ score || 0 }}</strong>
                </div>
                <div
                    class="chances-bt"
                    :class="{ active: isShowMenu === 'purchaseChances' }"
                    @click="getMenu('purchaseChances')"
                >
                    {{$t('PurchaseChances')}}<img width="16" src="../../static/images/by-i1.png" />
                </div>
            </div>

            <div class="menu-list">
                <div :class="{ active: isShowMenu === 'history' }" @click="getMenu('history')">
                    <img width="10" src="../../static/images/m-i1.png" />{{$t('History')}}
                </div>
                <div :class="{ active: isShowMenu === 'billing' }" @click="getMenu('billing')">
                    <img width="14" src="../../static/images/m-i2.png" />{{$t('Billing')}}
                </div>
                <div :class="{ active: isShowMenu === 'guidance' }" @click="getMenu('guidance')">
                    <img width="12" src="../../static/images/m-i3.png" />{{$t('Guidance')}}
                </div>
                <div :class="{ active: isShowMenu === 'invitation' }" @click="getMenu('invitation')">
                    <img width="14" src="../../static/images/m-i4.png" />{{$t('invitation')}}
                </div>
                <div :class="{ active: isShowMenu === 'faq' }" @click="getMenu('faq')">
                    <img width="14" src="../../static/images/m-i5.png" />{{$t('FAQ')}}
                </div>
<!--                <div :class="{ active: isShowMenu === 'language' }" @click="openLanguageDialog">-->
<!--                    <img width="14" src="../../static/images/en.png" />{{$t('language')}}-->
<!--                </div>-->
            </div>

            <div class="ac">
                <button class="button" style="width: 100%;" @click="unSubscribe">{{$t('unsubscribe')}}</button>
            </div>
        </div>

        <!-- Language Dialog（复用 HeaderOne.vue 交互） -->
        <Dialog
            ref="imgDialog"
            type="alert"
            title=""
            width="100"
            :modalFoot="false"
            :iscloseMask="true"
            style="min-height: 300px; z-index: 1500"
        >
            <div class="alert-modal" style="width: 95%;" slot="mdBox">
                <div class="close" @click="closeLanguageDialog" style="text-align: right; margin: 0 auto; font-size: 50px;">
                    ×
                </div>
                <div class="information crfff ac por">
                    <div class="fs50">{{$t('language')}}</div>
                    <div class="fs26 mt30 cr0062ff">{{$t('languageTips')}} :</div>
                    <div class="change-list change-list2 ac">
                        <div class="one" @click="pickLang('en')" :class="{ active: isShowLang === 'en' }">
                            <img class="dui" src="../../static/images/dui.png" />
                            <img style="width: 1.2rem" src="../../static/images/en.jpg" />
                            <span>{{$t('English')}}</span>
                        </div>
                        <div class="one" @click="pickLang('bur')" :class="{ active: isShowLang === 'bur' }">
                            <img class="dui" src="../../static/images/dui.png" />
                            <img style="width: 1.2rem" src="../../static/images/en1.jpg" />
                            <span>{{$t('Myanmar')}}</span>
                        </div>
                    </div>
                    <div class="ac mt50">
                        <button class="button fw7" @click="applyLang">{{$t('change')}}</button>
                    </div>
                </div>
            </div>
        </Dialog>

        <div class="home-content">
            <div class="content crfff ac por">
                <!-- 轮播图区域（保留原有逻辑与样式） -->
                <div class="banner-container" ref="bannerContainer">
                    <div class="banner-wrapper">
                        <div
                            v-for="(banner, index) in bannerList"
                            :key="index"
                            class="banner-item"
                            :class="{ active: currentBannerIndex === index }"
                            @click="goToBannerLink(banner)"
                        >
                            <img :src="banner.image" :alt="banner.title || 'banner'" class="banner-image" />
                        </div>
                    </div>
                    <div class="banner-indicator" v-if="bannerList && bannerList.length > 1">
                        <span
                            v-for="(banner, index) in bannerList"
                            :key="index"
                            class="indicator-dot"
                            :class="{ active: currentBannerIndex === index }"
                            @click="goToBanner(index)"
                        ></span>
                    </div>
                </div>

                <div class="home-categories">
                    <div class="home-section-title">{{$t('categories')}}</div>
                    <div class="home-cate-row">
                        <button
                            class="home-cate"
                            type="button"
                            :class="{ active: currentTabIndex === 'trending' }"
                            @click="changeTab('trending')"
                        >
                            <img class="home-cate-icon" src="../../static/images/index/index_cate_trending.png" alt="" />
                            <div class="home-cate-label">{{$t('Trending')}}</div>
                        </button>
                        <button
                            class="home-cate"
                            type="button"
                            :class="{ active: currentTabIndex === 'face_magic' }"
                            @click="changeTab('face_magic')"
                        >
                            <img class="home-cate-icon" src="../../static/images/index/index_cate_facemagic.png" alt="" />
                            <div class="home-cate-label">{{$t('Face_Magic')}}</div>
                        </button>
                      <button
                        class="home-cate"
                        type="button"
                        :class="{ active: currentTabIndex === 'beauty' }"
                        @click="changeTab('beauty')"
                      >
                        <img class="home-cate-icon" src="../../static/images/ai_beauty/beauty.png" alt="" />
                        <div class="home-cate-label">{{$t('beauty_category')}}</div>
                      </button>
                        <button
                            class="home-cate"
                            type="button"
                            :class="{ active: currentTabIndex === 'ai_studio' }"
                            @click="changeTab('ai_studio')"
                        >
                            <img class="home-cate-icon" src="../../static/images/index/index_cate_aistudio.png" alt="" />
                            <div class="home-cate-label">{{$t('AI_Studio')}}</div>
                        </button>
<!--                        <button-->
<!--                            class="home-cate"-->
<!--                            type="button"-->
<!--                            :class="{ active: currentTabIndex === 'ai_doc' }"-->
<!--                            @click="changeTab('ai_doc')"-->
<!--                        >-->
<!--                            <img class="home-cate-icon" src="../../static/images/index/index_cate_aidoc.png" alt="" />-->
<!--                            <div class="home-cate-label">{{$t('ai_doc')}}</div>-->
<!--                        </button>-->
                    </div>
                </div>

                <div class="home-trending-title">
                    <img class="home-trending-icon" :src="currentSectionMeta.icon" alt="" />
                    <span>{{ currentSectionMeta.title }}</span>
                </div>

                <!-- AI Doc：不走 product/list，直接静态布局 -->
                <div v-if="currentTabIndex === 'ai_doc'" class="ai-doc-section">
                    <div class="ai-doc-card" @click="goDetail('/aiPpt')">
                        <div class="ai-doc-icon">
                            <img src="../../static/images/index/index_ai_ppt.png" alt="" />
                        </div>
                        <div class="ai-doc-copy">
                            <div class="ai-doc-title">{{$t('ai_ppt_title')}}</div>
                            <div class="ai-doc-desc">
                              {{$t('ai_ppt_tip')}}
                            </div>
                        </div>
                        <div class="ai-doc-go">
                            <img src="../../static/images/index/index_ai_doc_go.png" alt="" />
                        </div>
                    </div>

                    <div class="ai-doc-card" @click="goDetail('/aiResume')">
                        <div class="ai-doc-icon">
                            <img src="../../static/images/index/index_ai_resume.png" alt="" />
                        </div>
                        <div class="ai-doc-copy">
                            <div class="ai-doc-title">{{$t('ai_resume_title')}}</div>
                            <div class="ai-doc-desc">
                              {{$t('ai_resume_tip')}}
                            </div>
                        </div>
                        <div class="ai-doc-go">
                            <img src="../../static/images/index/index_ai_doc_go.png" alt="" />
                        </div>
                    </div>
                </div>
                <div v-else-if="currentTabIndex === 'beauty'" class="land-content al">
                    <div class="land-col">
                        <div v-for="(item, index) in leftBeautyEntries" :key="item.path || 'bl-' + index">
                            <div class="two" @click="goDetail(item.path)">
                                <div class="cover-wrap">
                                    <img :src="item.image" loading="lazy" :alt="item.title" />
                                    <div class="cover-title">{{ item.title }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="land-col">
                        <div v-for="(item, index) in rightBeautyEntries" :key="item.path || 'br-' + index">
                            <div class="two" @click="goDetail(item.path)">
                                <div class="cover-wrap">
                                    <img :src="item.image" loading="lazy" :alt="item.title" />
                                    <div class="cover-title">{{ item.title }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 其它分类：产品瀑布流 -->
                <div v-else class="land-content al">
                    <div class="land-col">
                        <div v-for="(item, index) in leftProducts" :key="item.id || 'l-' + index">
                            <div class="two" @click="goDetail(item.web_path)">
                                <img
                                    v-if="item.is_new"
                                    style="position: absolute;right: 0px;top: -20px;width: 40%"
                                    src="../../static/images/Festival_icon.png"
                                />
                                <div class="cover-wrap">
                                    <img :src="item.image" loading="lazy" />
                                    <template v-if="item.type === 'video'">
                                        <div class="cover-tags-bar">
                                            <span class="cover-tag cover-tag-left">
                                                <img class="cover-tag-icon" src="../../static/images/camera.png" alt="" />
                                                {{$t('Shoot_same_video')}}
                                            </span>
                                            <span v-if="item.video_time" class="cover-tag cover-tag-right">{{ item.video_time }}</span>
                                        </div>
                                    </template>
                                    <div class="cover-title">{{ item.title }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="land-col">
                        <div v-for="(item, index) in rightProducts" :key="item.id || 'r-' + index">
                            <div class="two" @click="goDetail(item.web_path)">
                                <img
                                    v-if="item.is_new"
                                    style="position: absolute;right: 0px;top: -20px;width: 40%"
                                    src="../../static/images/Festival_icon.png"
                                />
                                <div class="cover-wrap">
                                    <img :src="item.image" loading="lazy" />
                                    <template v-if="item.type === 'video'">
                                        <div class="cover-tags-bar">
                                            <span class="cover-tag cover-tag-left">
                                                <img class="cover-tag-icon" src="../../static/images/camera.png" alt="" />
                                                {{$t('Shoot_same_video')}}
                                            </span>
                                            <span v-if="item.video_time" class="cover-tag cover-tag-right">{{ item.video_time }}</span>
                                        </div>
                                    </template>
                                    <div class="cover-title">{{ item.title }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <button
            v-show="showBackTop"
            class="back-top-btn"
            type="button"
            aria-label="Back to top"
            @click="backToTop"
        >
            ↑
        </button>
<!--        <div class="footer ac crfff disflex mt100">-->
<!--          <a href="/" class="home">-->
<!--            <img style="width: 0.4rem" src="../../static/images/home.png">-->
<!--            <div class="span crfff">{{$t('Home')}}</div>-->
<!--          </a>-->
<!--          <div class="snapbot-ft ac" @click="goDetail('/snapbot')">-->
<!--            <div class="snapbot-img">-->
<!--              <img style="width: 1.4rem" src="../../static/images/snapbot-btn.png">-->
<!--            </div>-->
<!--            <div class="span crff4fc7">{{$t('snapbot')}}</div>-->
<!--          </div>-->
<!--          <a href="/#/myAccount" class="account-ft">-->
<!--            <img style="width: 0.4rem" src="../../static/images/account-icon.png">-->
<!--            <div class="span crfff">{{$t('profile')}}</div>-->
<!--          </a>-->
<!--        </div>-->

        <!-- Spin Wheel 弹窗 -->
        <div v-if="showSpinPopup" class="spin-popup">
            <div class="popup-overlay" @click="closeSpinPopup"></div>
            <div class="popup-content">
                <div class="popup-title">{{$t('spin_tip_1')}}</div>
                <div class="popup-subtitle">
                    {{$t('spin_tip_2')}}
                </div>
                <div class="wheel-container" @click="goSpinPage">
                    <img src="../../static/images/spin_wheel.png" alt="wheel" class="wheel-img" />
                </div>
                <button class="letsgo-btn" @click="goSpinPage"></button>
                <div class="close" @click="closeSpinPopup">{{$t('close')}}</div>
            </div>
        </div>
    </div>
</template>

<script>
import Dialog from '../components/dialog'

export default {
    components: {
        Dialog
    },
    computed: {
        // 按原始顺序，偶数索引在左列，奇数索引在右列
        leftProducts () {
            if (!Array.isArray(this.product)) return []
            return this.product.filter((_, idx) => idx % 2 === 0)
        },
        rightProducts () {
            if (!Array.isArray(this.product)) return []
            return this.product.filter((_, idx) => idx % 2 === 1)
        },
        leftBeautyEntries () {
            if (!Array.isArray(this.beautyEntries)) return []
            return this.beautyEntries.filter((_, idx) => idx % 2 === 0)
        },
        rightBeautyEntries () {
            if (!Array.isArray(this.beautyEntries)) return []
            return this.beautyEntries.filter((_, idx) => idx % 2 === 1)
        },
        currentSectionMeta () {
            const key = this.currentTabIndex || 'trending'
            const metaMap = {
                trending: {
                    icon: '../../static/images/index/index_cate_trending.png',
                    titleKey: 'Trending',
                    fallbackTitle: 'Trending'
                },
                face_magic: {
                    icon: '../../static/images/index/index_cate_facemagic.png',
                    titleKey: 'Face_Magic',
                    fallbackTitle: 'Face Magic'
                },
                ai_studio: {
                    icon: '../../static/images/index/index_cate_aistudio.png',
                    titleKey: 'AI_Studio',
                    fallbackTitle: 'AI Studio'
                },
                ai_doc: {
                    icon: '../../static/images/index/index_cate_aidoc.png',
                    titleKey: 'ai_doc',
                    fallbackTitle: 'AI Doc'
                },
                beauty: {
                    icon: '../../static/images/ai_beauty/beauty.png',
                    titleKey: 'beauty_category',
                    fallbackTitle: 'Beauty'
                }
            }
            const meta = metaMap[key] || metaMap.trending
            let title = meta.fallbackTitle
            try {
                const t = this.$t && this.$t(meta.titleKey)
                if (t && t !== meta.titleKey) title = t
            } catch (e) {}
            return { icon: meta.icon, title }
        },
        homeSnapbotBgStyle () {
            const isBur = this.isEN === 'bur'
            // 让打包器正确处理静态资源
            const url = isBur
                ? require('../../static/images/index/index_snapbot_mm.png')
                : require('../../static/images/index/index_snapbot.png')
            return { backgroundImage: `url(${url})` }
        },
        beautyEntries () {
            return [
                {
                    path: '/aiMakeup',
                    title: this.$t('ai_makeup_title'),
                    image: require('../../static/images/ai_beauty/aiMakeup.png')
                },
                {
                    path: '/aiLookVto',
                    title: this.$t('ai_look_title'),
                    image: require('../../static/images/ai_beauty/aiLookVto.png')
                },
                {
                    path: '/aiHairColor',
                    title: this.$t('ai_hair_color_title'),
                    image: require('../../static/images/ai_beauty/aiHairColor.png')
                },
                {
                    path: '/aiClothes',
                    title: this.$t('ai_clothes_title'),
                    image: require('../../static/images/ai_beauty/aiClothes.png')
                },
                {
                    path: '/aiBag',
                    title: this.$t('ai_bag_title'),
                    image: require('../../static/images/ai_beauty/aiBag.png')
                }
            ]
        }
    },
    data() {
        return {
            info: {},
            isShow: 1,
            isEN: 'bur',
            menuActive: false,
            isShowMenu: false,
            lang: '',
            isShowLang: 'bur',
            score: '',
            mobile: '',
            switchFeature: false,
            product: [],
            showSpinPopup: false,
            tabType: 0,
            // 分页相关
            currentPage: 1,
            pageLimit: 10,
            hasMore: true,
            isLoading: false,
            // 轮播相关数据（由 product/banner 接口加载，初始为空避免 undefined）
            bannerList: [],
            currentBannerIndex: 0,
            bannerTimer: null,
            bannerInterval: 3000, // 3秒自动切换
            touchStartX: 0,
            touchEndX: 0,
            currentTabIndex:'trending',
            // 新增的悬停相关数据
            isTabSticky: false,
            tabHeight: 0,
            scrollThreshold: 0,
            lastScrollTop: 0,
            ticking: false,
            scrollDirection: 'down', // 'down' 或 'up'
            showBackTop: false
        }
    },
    mounted() {
      // 启动轮播
      this.startBannerAutoPlay();

      // 添加触摸事件
      this.addTouchEvents();

      // 添加滚动监听
      window.addEventListener('scroll', this.handleScroll, { passive: true });

      // 添加产品列表滚动加载监听
      window.addEventListener('scroll', this.handleProductScroll, { passive: true });

      // 监听窗口大小变化
      window.addEventListener('resize', this.onResize);

      // 初始化计算位置
      this.$nextTick(() => {
        this.calculateTabPosition();
      });
    },
    beforeDestroy() {
      // 清除轮播定时器
      this.stopBannerAutoPlay();
      // 移除触摸事件
      this.removeTouchEvents();

      // 移除事件监听
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('scroll', this.handleProductScroll);
      window.removeEventListener('resize', this.onResize);
    },
    created() {
        this.isEN = localStorage.getItem('lang')
        if (this.isEN) {
            this.isShowLang = this.isEN
        }
        if (this.$route.query.msisdn) {
            this.mobile = this.$route.query.msisdn
            this.getLogin()
        } else {
            this.getHome()
            this.getBanner()
            this.getProduct(true) // 首次加载重置
        }
    },
    methods: {
        toggleMenu(open) {
            this.menuActive = !!open
        },
        getMenu(url) {
            this.isShowMenu = url
            this.toggleMenu(false)
            setTimeout(() => {
                this.$router.push({ path: url, query: { url } })
            }, 200)
        },
        openLanguageDialog() {
            this.isShowMenu = 'language'
            if (this.$refs.imgDialog && this.$refs.imgDialog.showMaskFun) {
                this.$refs.imgDialog.showMaskFun()
            }
        },
        closeLanguageDialog() {
            if (this.$refs.imgDialog && this.$refs.imgDialog.closeMask) {
                this.$refs.imgDialog.closeMask()
            }
        },
        pickLang(lang) {
            this.isShowLang = lang
            this.lang = lang
        },
        applyLang() {
            const lang = this.lang || this.isShowLang || 'bur'
            localStorage.setItem('lang', lang)
            location.reload()
        },
        startBannerAutoPlay() {
            if (!this.bannerList || this.bannerList.length <= 1) return;
            this.bannerTimer = setInterval(() => {
                this.nextBanner();
            }, this.bannerInterval);
        },

        // 停止自动轮播
        stopBannerAutoPlay() {
            if (this.bannerTimer) {
                clearInterval(this.bannerTimer);
                this.bannerTimer = null;
            }
        },

        // 切换到下一个轮播
        nextBanner() {
            if (!this.bannerList || this.bannerList.length <= 1) return;
            this.currentBannerIndex = (this.currentBannerIndex + 1) % this.bannerList.length;
        },

        // 切换到上一个轮播
        prevBanner() {
            if (!this.bannerList || this.bannerList.length <= 1) return;

            this.currentBannerIndex = this.currentBannerIndex === 0
                ? this.bannerList.length - 1
                : this.currentBannerIndex - 1;
        },

        // 跳转到指定轮播
        goToBanner(index) {
            if (!this.bannerList || index < 0 || index >= this.bannerList.length) return;
            this.currentBannerIndex = index;
        },

        // 点击轮播图片跳转
        goToBannerLink(banner) {
            if (banner && banner.link) {
                this.$router.push(banner.link);
            }
        },

        // 重新开始自动轮播
        restartBannerAutoPlay() {
            this.stopBannerAutoPlay();
            this.startBannerAutoPlay();
        },

        // 添加触摸事件
        addTouchEvents() {
            const container = this.$refs.bannerContainer;
            if (!container) return;

            container.addEventListener('touchstart', this.handleTouchStart);
            container.addEventListener('touchend', this.handleTouchEnd);
        },

        // 移除触摸事件
        removeTouchEvents() {
            const container = this.$refs.bannerContainer;
            if (!container) return;

            container.removeEventListener('touchstart', this.handleTouchStart);
            container.removeEventListener('touchend', this.handleTouchEnd);
        },

        // 触摸开始
        handleTouchStart(e) {
            this.touchStartX = e.changedTouches[0].clientX;
        },

        // 触摸结束
        handleTouchEnd(e) {
            this.touchEndX = e.changedTouches[0].clientX;
            this.handleSwipe();
        },

        // 处理滑动
        handleSwipe() {
            const swipeThreshold = 50;
            const diff = this.touchStartX - this.touchEndX;

            if (Math.abs(diff) > swipeThreshold) {
                if (diff > 0) {
                    this.nextBanner();
                } else {
                    this.prevBanner();
                }
            }
        },

        getContent(type) {
            // 兼容旧逻辑：保留空实现
        },

        getLogin() {
            let that = this
            that.$parent.loadModal(true);
            let data = {
                mobile: that.mobile
            }
            that.$api.post('/api/user/fast_login', data, r => {
                that.$parent.loadModal(false);
                if (r.code == 1) {
                    localStorage.setItem('token', r.data.userinfo.token)
                    localStorage.setItem('mobile', r.data.userinfo.mobile)
                    this.getHome();
                    this.getBanner()
                    this.getProduct(true); // 登录后首次加载重置
                } else {
                    that.$utils.alertText(r.msg, 80);
                    this.$router.push({ path: '/land', query: { msisdn: that.mobile } })
                }
            })
        },

        getHome() {
            let that = this;
            that.$api.get('/api/user/info', null, r => {
                that.$parent.returnCode(r, function() {
                    that.info = r.data || {}
                    that.score = r.data.score
                });
            })
        },

        getProduct(reset = false) {
            let that = this;

            // 如果重置，清空数据并重置分页
            if (reset) {
                that.product = [];
                that.currentPage = 1;
                that.hasMore = true;
            }

            // 如果正在加载或没有更多数据，则不请求
            if (that.isLoading || !that.hasMore) {
                return;
            }

            that.isLoading = true;
            let data = {
                'group': that.currentTabIndex,
                'page': that.currentPage,
                'limit': that.pageLimit
            };

            that.$api.post('/api/product/list', data, r => {
                that.isLoading = false;
                that.$parent.returnCode(r, function () {
                    if (r.data && r.data.list) {
                        // 追加新数据
                        that.product = that.product.concat(r.data.list);
                        that.hasMore = r.data.hasMore || false;
                        that.currentPage += 1;
                    } else {
                        // 兼容旧接口格式（如果没有分页信息，直接使用返回的数据）
                        if (Array.isArray(r.data)) {
                            that.product = reset ? r.data : that.product.concat(r.data);
                            that.hasMore = r.data.length >= that.pageLimit;
                            that.currentPage += 1;
                        }
                    }
                });
            }, () => {
                that.isLoading = false;
            })
        },
        getBanner() {
          let that = this;
          that.$api.post('/api/product/banner', null, r => {
            that.$parent.returnCode(r, function () {
              that.bannerList = Array.isArray(r.data) ? r.data : [];
              that.currentBannerIndex = 0;
              that.restartBannerAutoPlay();
            });
          }, () => {
            that.bannerList = [];
          });
        },
        goDetail(path) {
            this.$router.push({ path: path });
        },
        goPurchaseChances() {
            this.$router.push({ path: '/purchaseChances' })
        },

        unSubscribe() {
            let that = this
            that.$parent.loadModal(true)
            that.$api.post('api/user/unsub', null, r => {
                that.$parent.returnCode(r, function () {
                    that.$parent.loadModal(false)
                    that.$utils.alertText(r.msg, 80)
                    localStorage.removeItem('token')
                    localStorage.removeItem('mobile')
                    that.$router.push({path:'/login'});
                })
            })
        },

        openSpinPopup() {
            this.showSpinPopup = true;
        },

        closeSpinPopup() {
            this.showSpinPopup = false;
        },

        goSpinPage() {
            this.$router.push({ path: '/spin' });
        },
        changeTab(type) {
          this.currentTabIndex = type;
          // AI Doc 不走 product/list
          if (type === 'ai_doc') return
          // 其它 tab：切换时重置并重新加载
          this.getProduct(true);
        },
      // 计算 tab 位置和高度
      calculateTabPosition() {
        // 新版首页不再使用吸顶 tab，保留函数避免外部调用报错
      },

      // 窗口大小变化处理
      onResize() {
        this.calculateTabPosition();
      },
      // 处理滚动
      handleScroll() {
        if (!this.ticking) {
          this.ticking = true;
          requestAnimationFrame(() => {
            this.updateTabSticky();
            this.ticking = false;
          });
        }
      },


      // 更新 tab 悬停状态
      updateTabSticky() {
        // 新版首页不再使用吸顶 tab，但这里复用滚动帧回调做“返回顶部”显示控制
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
        this.showBackTop = scrollTop > (window.innerHeight || 600);
      },

      // 处理产品列表滚动加载
      handleProductScroll() {
        if (this.isLoading || !this.hasMore) {
          return;
        }

        // 计算距离底部的距离
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const windowHeight = window.innerHeight || document.documentElement.clientHeight;
        const documentHeight = document.documentElement.scrollHeight || document.body.scrollHeight;

        // 当滚动到距离底部 200px 时加载下一页
        const threshold = 200;
        if (scrollTop + windowHeight >= documentHeight - threshold) {
          this.getProduct(false);
        }
      },

      backToTop() {
        try {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        } catch (e) {
          window.scrollTo(0, 0);
        }
      }
    }
}
</script>

<style scoped>
/* 新版首页：按设计图重排 */
.home-page0 {
    position: relative;
    min-height: 100vh;
    background: transparent;
    color: #fff;
    /* 覆盖全局 .home-page 的顶部留白（原来给固定 Header 预留的） */
    padding-top: 0 !important;
    padding-bottom: 1.8rem;
}

/* 固定背景层：避免页面变长导致 cover “放大裁切” */
.home-page0::before {
    content: '';
    position: fixed;
    inset: 0;
    z-index: -1;
    pointer-events: none;
    background: url('../../static/images/index/index_bg.jpg') no-repeat center top;
    background-size: cover;
}

/* 轮播图样式（原有保留） */
.banner-container {
    position: relative;
    width: 100%;
    height: 4.5rem;
    overflow: hidden;
    padding-bottom: 0.6rem;
    margin-top: 0.12rem;
}

.banner-wrapper {
    width: 100%;
    height: 100%;
    position: relative;
}

.banner-item {
    position: absolute;
    width: 100%;
    height: 100%;
    opacity: 0;
    transition: opacity 0.5s ease-in-out;
    cursor: pointer;
    pointer-events: none;
}

.banner-item.active {
    opacity: 1;
    pointer-events: auto;
}

.banner-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 0.4rem;
}

.banner-indicator {
    position: absolute;
    bottom: 0.2rem;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
    gap: 0.08rem;
    z-index: 2;
}

.indicator-dot {
    width: 0.12rem;
    height: 0.12rem;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.5);
    cursor: pointer;
    transition: all 0.3s ease;
}

.indicator-dot.active {
    background: white;
    transform: scale(1.2);
}

.home-hero {
    position: relative;
    padding: 0.24rem 0.3rem 0.22rem;
    background: transparent;
}

.home-topbar {
    display: grid;
    grid-template-columns: 1fr auto auto;
    align-items: center;
    gap: 0.18rem;
    padding-top: 0.08rem;
}

.home-brand {
    display: flex;
    align-items: center;
    min-width: 0;
}

.home-logo {
    width: 3.0rem;
    height: auto;
    display: block;
}

.home-chances {
    display: inline-flex;
    align-items: center;
    gap: 0.12rem;
    padding: 0 0.8rem;
    height: 0.72rem;
    aspect-ratio: 301 / 111;
    border: none;
    background: url('../../static/images/index/index_chance_bg.png') no-repeat center;
    background-size: contain;
    color: #fff;
    font-weight: 700;
}

.home-chances-icon {
    width: 0.6rem;
    height: 0.6rem;
    background: url('../../static/images/hd-i1.png') no-repeat center;
    background-size: contain;
    display: inline-block;
}

.home-chances-value {
    font-size: 0.28rem;
    line-height: 1;
}

.home-menu {
    width: 0.6rem;
    height: 0.6rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0;
}

.home-menu-icon {
    width: 0.8rem;
    height: 0.8rem;
    display: block;
}

.home-snapbot {
    position: relative;
    margin-top: 0.18rem;
    width: 80%;
    margin-left: auto;
    margin-right: auto;
    aspect-ratio: 770 / 260;
    height: auto;
    padding: 0;
    border: none;
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100% 100%;
    color: #fff;
    display: block;
}

.home-snapbot-content {
    display: none;
}

.home-snapbot-copy {
    display: none;
}

.home-content {
    padding: 0 0.3rem;
}

.home-categories {
    margin-top: 0.18rem;
    padding: 0.22rem 0.22rem 0.18rem;
    background: url('../../static/images/index/index_cate_bg.png') no-repeat center;
    background-size: 100% 100%;
    backdrop-filter: blur(0.06rem);
    overflow: hidden;
}

.home-section-title {
    font-size: 0.3rem;
    font-weight: 800;
    margin-bottom: 0.18rem;
    text-align: center;
}

.home-cate-row {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 0.14rem;
}

.home-cate {
    padding: 0.18rem 0.12rem 0.14rem;
    border-radius: 0;
    border: none;
    outline: none;
    background: url('../../static/images/index/index_acte_bg_normal.png') no-repeat center;
    background-size: contain; /* 不裁切，确保背景图完整显示 */
    color: #fff;
    text-align: center;
    aspect-ratio: 1 / 1; /* 背景图是正方形 237x237，避免因内容撑高导致显示不全 */
    box-sizing: border-box;
    min-width: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.home-cate.active {
    background-image: url('../../static/images/index/index_cate_bg_act.png');
}

.home-cate:focus {
    outline: none;
}

.home-cate-icon {
    width: 0.62rem;
    height: 0.62rem;
    margin: 0 0 0.08rem;
    display: block;
}

.home-cate-label {
    font-size: 0.2rem;
    line-height: 1.7;
    opacity: 0.95;
    max-width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: center;
}

.home-trending-title {
    margin: 0.26rem 0 0.18rem;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.1rem;
    font-size: 0.32rem;
    font-weight: 800;
}

.home-trending-icon {
    width: 0.38rem;
    height: 0.38rem;
    display: block;
}

.ai-doc-section {
    padding: 0.1rem 0;
}

.ai-doc-card {
    position: relative;
    display: flex;
    align-items: center;
    gap: 0.18rem;
    padding: 0.22rem 0.22rem;
    margin: 0 0 0.22rem 0;
    border-radius: 0.26rem;
    background: url('../../static/images/index/index_ai_ppt_bg.png') no-repeat center;
    background-size: 100% 100%;
    overflow: hidden;
    text-align: left;
}

.ai-doc-icon {
    width: 1.05rem;
    height: 1.05rem;
    flex: 0 0 auto;
}

.ai-doc-icon img {
    width: 100%;
    height: 100%;
    display: block;
}

.ai-doc-copy {
    flex: 1;
    min-width: 0;
}

.ai-doc-title {
    font-size: 0.32rem;
    font-weight: 800;
    margin-bottom: 0.1rem;
}

.ai-doc-desc {
    font-size: 0.24rem;
    line-height: 1.25;
    opacity: 0.9;
    width: 80%;
}

.ai-doc-go {
    position: absolute;
    right: 0.1rem;
    bottom: 0rem;
    width: 0.62rem;
    height: 0.62rem;
    display: block;
}

.ai-doc-go img {
    width: 0.62rem;
    height: 0.62rem;
    display: block;
}

.back-top-btn {
    position: fixed;
    right: 0.28rem;
    bottom: 1.0rem; /* 避开底部悬浮 footer */
    width: 0.92rem;
    height: 0.92rem;
    border-radius: 999px;
    border: 1px solid rgba(255, 255, 255, 0.14);
    background: rgba(16, 18, 32, 0.75);
    backdrop-filter: blur(0.06rem);
    color: #fff;
    font-size: 0.44rem;
    line-height: 0.92rem;
    text-align: center;
    z-index: 1200;
}

.back-top-btn:active {
    transform: translateY(0.02rem);
}

/* 原有样式保持不变 */
.new-img {
    margin: 0.4rem 0.4rem 0;
    width: auto;
}

.new-img .img-b {
    width: 48%;
    border: 0.04rem solid #0062ff;
    border-radius: 0.1rem;
}

.img-b img {
    width: 100%;
    border-radius: 0.1rem;
}

.snapbot-btn {
    background: url('../../static/images/snapbot-btn.png') no-repeat center center;
    background-size: contain;
    width: 5rem;
    height: 0.9rem;
    border: none;
}

.spin-btn {
    background: url('../../static/images/lucky_spin_btn.png') no-repeat center center;
    background-size: contain;
    width: 5rem;
    height: 0.9rem;
    border: none;
}

.spin-popup {
    position: fixed;
    z-index: 9999;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.popup-overlay {
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    backdrop-filter: blur(0.04rem);
}

.popup-content {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    color: #fff;
    width: 90%;
}

.popup-title {
    font-size: 0.45rem;
    font-weight: 700;
    margin-bottom: 0.1rem;
}

.popup-subtitle {
    font-size: 0.3rem;
    color: #7fffd4;
    margin: 0.2rem auto 0.2rem;
}

.wheel-container {
    position: relative;
}

.wheel-img {
    width: 100%;
    border-radius: 50%;
}

.letsgo-btn {
    background: url('../../static/images/let_go.png') no-repeat center center;
    background-size: contain;
    padding: 0.7rem 1.8rem;
}



/* 首页产品：自定义两列瀑布流，覆盖全局 column-count 布局 */
.land-content {
    display: flex;
    align-items: flex-start;
    column-count: 1; /* 禁用多列布局，避免“先排满左边再右边” */
    column-gap: 0;
}

.land-col {
    flex: 1;
}

.land-col:first-child {
    margin-right: 0.1rem;
}

.land-col .two {
    width: 100%;
    margin: 0 0 0.1rem 0;
}

.cover-wrap {
    position: relative;
    display: block;
    width: 100%;
    border-radius: 0.18rem;
    overflow: hidden;
}
.cover-wrap > img {
    display: block;
    width: 100%;
    border-radius: 0.18rem;
}
.cover-tags-bar {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    padding: 0.1rem 0.1rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: linear-gradient(rgba(0, 0, 0, 0.65), rgba(0, 0, 0, 0));
}
.cover-tag {
    position: static;
    font-size: 0.22rem;
    color: #fff;
    padding: 0.04rem 0.1rem;
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.12);
    border-radius: 0.08rem;
    display: inline-flex;
    align-items: center;
    line-height: 1.1;
}
.cover-tag-left .cover-tag-icon {
    width: 0.28rem;
    height: 0.28rem;
    margin-right: 0.06rem;
    flex-shrink: 0;
}
.cover-tag-left {}
.cover-tag-right {}

.cover-title {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    font-size: 0.2rem;
    color: #fff;
    text-align: center;
    padding: 0.16rem 0.18rem 0.14rem;
    line-height: 1.2;
    background: linear-gradient(transparent, rgba(0, 0, 0, 0.8));

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/page/index.vue